// data/projects.js

const projectData = [
  {
    id: "oracle-fusion-invoicing",
    title: "Oracle Fusion Invoicing System",
    year: "2026",
    featured: true,
    tags: ["Oracle Fusion", "Invoicing", "Enterprise"],
    images: [],
    imageAlt:
      "Oracle Fusion invoicing workflow case study visual",
    description:
      "Built enterprise invoicing workflows for a telecom environment with Oracle Fusion API integration, invoice sync, status tracking, validation rules, and finance operations support. The work focused on reliable ERP data exchange, clear audit trails, and practical usability for a Saudi business environment.",
    technologies: [
      "React.js",
      "Node.js",
      "Oracle Fusion REST APIs",
      "MongoDB",
      "Express.js",
      "MUI",
      "JWT",
      "RBAC"
    ],
    outcomes: [
      "Connected invoice workflows with Oracle Fusion API endpoints.",
      "Improved visibility into invoice states, sync results, and exceptions.",
      "Designed admin-friendly screens for review, correction, and operational follow-up."
    ],
    demoLink: "",
    ghLink: null,
  },
  {
    id: "accounting-gl-pl-balance-sheet",
    title: "Accounting Software with GL, P&L and Balance Sheet",
    year: "2026",
    featured: true,
    tags: ["Accounting", "GL", "Reports"],
    images: [],
    imageAlt:
      "Accounting software reporting case study visual",
    description:
      "Developed accounting software modules for business finance workflows, including general ledger structures, invoice records, P&L reporting, balance sheet views, account summaries, and financial data organization for day-to-day operations.",
    technologies: [
      "React.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "MUI",
      "Financial Reporting",
      "Role-Based Access"
    ],
    outcomes: [
      "Organized accounting data around GL, revenue, expenses, liabilities, and equity.",
      "Built reporting views for P&L and balance sheet analysis.",
      "Created workflows that support finance users without exposing private client details."
    ],
    demoLink: "",
    ghLink: null,
  },
  {
    id: "saas-dashboard",
    title: "SaaS Dashboard",
    year: "2026",
    featured: true,
    tags: ["SaaS", "Dashboard", "React"],
    images: [],
    imageAlt:
      "SaaS dashboard analytics and admin workflow case study visual",
    description:
      "Designed responsive SaaS dashboard experiences for admin users, operations teams, and product owners. The dashboards focused on clean navigation, analytics summaries, account management, approval flows, and reusable UI architecture.",
    technologies: [
      "React.js",
      "Next.js",
      "Node.js",
      "REST APIs",
      "MUI",
      "Charts",
      "Authentication"
    ],
    outcomes: [
      "Created responsive dashboard layouts for desktop, tablet, and mobile users.",
      "Improved operational visibility with summary metrics and action-oriented screens.",
      "Structured reusable components for faster feature delivery."
    ],
    demoLink: "",
    ghLink: null,
  },
  {
    id: "web3-wallet-integration",
    title: "Web3 DApp and Wallet Integration",
    year: "2026",
    featured: true,
    tags: ["Web3", "Wallets", "DApp"],
    images: [],
    imageAlt:
      "Web3 DApp wallet integration case study visual",
    description:
      "Implemented wallet-connected Web3 application flows with MetaMask, WalletConnect, Ethers.js, smart contract interaction, transaction status handling, and user-friendly blockchain feedback for DApp experiences.",
    technologies: [
      "React.js",
      "Next.js",
      "Ethers.js",
      "WalletConnect",
      "MetaMask",
      "Smart Contracts",
      "Web3Modal"
    ],
    outcomes: [
      "Built wallet login and chain-aware transaction flows.",
      "Added clear pending, success, and failure states for blockchain actions.",
      "Improved UX around contract calls, balances, approvals, and confirmations."
    ],
    demoLink: "",
    ghLink: null,
  },
  {
    id: "g2c",
    title: "Gift to Coin (G2C)",
    year: "2026",
    featured: true,
    tags: [
      "Web3",
      "Fintech",
      "MERN Stack",
      "Blockchain",
      "Binance Smart Chain"
    ],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1770831385/Screenshot_2026-02-11_223458_lgemsz.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1770831480/Screenshot_2026-02-11_223747_fpfdkh.png",
    ],
    description:
      "Developed a full-stack Web3 fintech platform for converting gift cards into USDT, BNB, and NGN. Designed and implemented the core swap engine using Ethers.js on Binance Smart Chain (BSC), featuring automated gas estimation, secure wallet integration, and blockchain transaction handling. Integrated Flutterwave for NGN bank transfers and Binance Pay for crypto payments. Built an admin dashboard for transaction verification, liquidity management, dispute handling, and platform analytics. Leveraged the MERN stack and modern UI architecture to deliver a secure, scalable, and user-friendly financial application.",
    technologies: [
      "React.js",
      "Node.js",
      "MongoDB",
      "Ethers.js",
      "Binance Smart Chain",
      "Material UI (MUI)",
      "Flutterwave",
      "Binance Pay"
    ],
    demoLink: "https://g2c-ruddy.vercel.app/",
    ghLink: null,
  },
  {
    id: "ubora-staking",
    title: "Ubora Staking",
    year: "2026",
    featured: true,
    tags: [
      "Web3",
      "Staking",
      "DeFi"
    ],
    images: [],
    description:
      "A robust Web3 cryptocurrency staking platform built with Angular and Node.js. It features direct wallet integrations (MetaMask, Coinbase Wallet), support for the NOWPayments gateway supporting over 100 cryptocurrencies, and automated external Binance Pay wallet syncing. Includes automated daily interest calculations, a user dashboard with secure KYC document uploads, and dual-signature admin approval flows for withdrawals.",
    technologies: [
      "Angular",
      "Tailwind CSS",
      "NgRx",
      "RxJS",
      "Ethers.js",
      "Node.js",
      "Express.js",
      "MySQL"
    ],
    demoLink: "",
    ghLink: null,
  },
  {
    id: "ubora-finance-digital",
    title: "Ubora Finance Digital",
    year: "2026",
    featured: true,
    tags: [
      "Web3",
      "DeFi",
      "Full-Stack"
    ],
    images: [],
    description:
      "A premium cryptocurrency staking and digital wallet management platform. Features a modern Next.js dashboard with live asset values via Coinbase & Binance API integration, Google Authenticator-based 2FA (TOTP) security, and dynamic staking pools with configurable reward yields. Also includes secure withdrawal whitelisting and an admin dashboard for user and KYC management.",
    technologies: [
      "Next.js",
      "ReactJS",
      "Tailwind CSS",
      "Prisma",
      "PostgreSQL",
      "Zod",
      "Zustand",
      "TypeScript"
    ],
    demoLink: "",
    ghLink: null,
  },
  {
    id: "ubora-trading-platform",
    title: "Ubora AI Trading Platform",
    year: "2026",
    featured: true,
    tags: [
      "Web3",
      "AI",
      "Fintech",
      "DeFi"
    ],
    images: [],
    description:
      "A high-frequency AI-driven trading ecosystem. It interfaces with MetaTrader 5 (MT5) via a custom MQL5 Expert Advisor bridge to stream market data and execute trades. The core is powered by a FastAPI Python engine using Pandas/NumPy to generate real-time scalping and daily trading signals, supported by a React frontend, Node.js server with Socket.io real-time updates, and Solidity smart contracts.",
    technologies: [
      "ReactJS",
      "Vite",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Python",
      "FastAPI",
      "Solidity",
      "MQL5",
      "Socket.io",
      "Ethers.js"
    ],
    demoLink: "",
    ghLink: null,
  },
  {
    id: "birb-base",
    title: "Birb Base Migration & Staking Portal",
    year: "2026",
    featured: true,
    tags: [
      "Web3",
      "DeFi",
      "Staking",
      "Migration"
    ],
    images: [],
    description:
      "A complete Web3 migration and staking portal designed for the $BIRB token. Facilitates token transition from the Binance Smart Chain (BSC) to the Base Network through a secure deposit-to-airdrop migration system. Features dynamic staking pools with real-time APR calculations, custom smart contract integration using Wagmi and Viem, multi-wallet connectivity via Web3Modal, and a fully responsive, modern dark-themed user interface.",
    technologies: [
      "Next.js",
      "ReactJS",
      "Wagmi",
      "Viem",
      "Web3Modal",
      "Chakra UI",
      "Tailwind CSS",
      "Framer Motion"
    ],
    demoLink: "https://birb.com",
    ghLink: "https://github.com/ahmadit575/birb-latest",
  },

  {
    id: "mate-finance",
    title: "Mate Finance",
    year: "2024",
    featured: true,
    tags: ["Web3", "DeFi", "Full-Stack"],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide_qrp8jl.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide1_fvtvhn.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487754/suicide2_fxqx1p.png",
    ],
    description:
      "An on-chain platform for tokenized invoice financing, connecting SMEs and DeFi investors for real yield. Features WalletConnect integration and smart contract interactions.",
    technologies: [
      "ReactJS",
      "NodeJS",
      "MongoDB",
      "MUI",
      "web3.js",
      "WalletConnect",
      "Smart Contracts",
    ],
    demoLink: "https://finbeta.invoicemate.net/",
    ghLink: null,
  },
  {
    id: "chat-mate",
    title: "ChatMate",
    year: "2024",
    featured: false,
    tags: ["Full-Stack", "Real-time", "MUI"],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750159670/blog_k9zww1.png",
    ],
    description:
      "ChatMate is an innovative real-time chat application built with ReactJS, offering smooth communication experiences with Socket.io integration.",
    technologies: [
      "ReactJS",
      "Firebase",
      "MUI",
      "Socket.io",
      "NodeJS",
      "MongoDB",
    ],
    demoLink: "https://chat.invoicemate.net/",
    ghLink: null,
  },
  {
    id: "biz-center",
    title: "Biz Center",
    year: "2024",
    featured: false,
    tags: ["Full-Stack", "SaaS", "Enterprise"],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750163572/codeEditor_ujow5o.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750163572/codeEditor1_w3v25y.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750163572/codeEditor2_lbken7.png",
    ],
    description:
      "Biz Center is a powerful accounting application designed to streamline financial management for businesses. It offers tools for tracking expenses, managing invoices, and generating financial reports.",
    technologies: ["ReactJS", "NodeJS", "MongoDB"],
    demoLink: "https://account.invoicemate.net/",
    ghLink: null,
  },
  {
    id: "claimoto",
    title: "Claimoto",
    year: "2024",
    featured: false,
    tags: ["Full-Stack", "Automation", "MUI"],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750164310/leaf2_uajudk.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750164308/leaf_mi4cvd.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750164312/leaf3_qkyitt.png",
    ],
    description:
      "A digital motor claims platform designed for automation, transparency, and seamless claims handling in the insurance industry.",
    technologies: ["ReactJS", "NodeJS", "MongoDB"],
    demoLink: "https://dev.claimoto.com",
    ghLink: null,
  },
  {
    id: "itradekash",
    title: "ItradeKash",
    year: "2024",
    featured: false,
    tags: ["Full-Stack", "FinTech", "Real-time"],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide_qrp8jl.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide1_fvtvhn.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487754/suicide2_fxqx1p.png",
    ],
    description:
      "A global currency exchange platform enabling secure peer-to-peer and market-driven currency trades with real-time updates.",
    technologies: ["ReactJS", "NodeJS", "MongoDB", "Bootstrap", "Socket.io"],
    demoLink: "https://itradekash.com/",
    ghLink: null,
  },
  {
    id: "mentorgrad",
    title: "Mentor Grad",
    year: "2024",
    featured: false,
    tags: ["Full-Stack", "EdTech", "Stripe"],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide_qrp8jl.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide1_fvtvhn.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487754/suicide2_fxqx1p.png",
    ],
    description:
      "MentorGrad connects aspiring international students with experienced mentors currently studying abroad. Features personalized mentorship, application guidance, and Stripe payment integration.",
    technologies: [
      "ReactJS",
      "NodeJS",
      "MongoDB",
      "Bootstrap",
      "Socket.io",
      "Stripe Integration",
    ],
    demoLink: "https://mentorgrad.com/",
    ghLink: null,
  },
  {
    id: "mototrolley",
    title: "Mototrolley",
    year: "2024",
    featured: false,
    tags: ["Full-Stack", "E-commerce", "MUI"],
    images: [
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide_qrp8jl.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487755/suicide1_fvtvhn.png",
      "https://res.cloudinary.com/dev7muzqa/image/upload/v1750487754/suicide2_fxqx1p.png",
    ],
    description:
      "World's 1st Automotive Spare Parts application providing more than 40 auto brands and 25,000,000+ part numbers for seamless ordering and delivery.",
    technologies: ["ReactJS", ".NET Core", "SQL Server", "MUI"],
    demoLink: "https://mototrolly.com/",
    ghLink: null,
  },

];

export default projectData;
